/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_RetryInputs */

const en_gc_editor_retry = /** @type {(inputs: Gc_Editor_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const zh_gc_editor_retry = /** @type {(inputs: Gc_Editor_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Gc_Editor_RetryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_retry = /** @type {((inputs?: Gc_Editor_RetryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_RetryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_retry(inputs)
	return zh_gc_editor_retry(inputs)
});
export { gc_editor_retry as "gc.editor.retry" }